<template>
  <b-modal
    :ref="modalRef"
    :id="`addCampaignToGroupModal-${id}`"
    :title="`Add Campaign to group`"
    data-test="add-campaign-to-group-modal"
    hide-footer
    hide-backdrop
    @shown="shownAddCampaignToGroupModal"
  >
    <div class="d-block">
      <p>Create or Select an existing Campaign Group</p>
      <b-form-group
        id="fieldset-campaign-group"
        label="Campaign Group"
        label-for="campaign-group-input"
        label-class="form-label"
      >
        <base-autocomplete
          id="search-groups"
          class="w-100"
          data-test="campaign-group-name-filter"
          :items="campaignGroups"
          :placeholder="'Search'"
          v-model="campaignGroupName"
          :search-text.sync="campaignGroupName"
        />
      </b-form-group>
    </div>
    <b-button
      class="mt-3"
      data-test="add-campaign-to-group-button"
      variant="primary"
      block
      @click="addCampaignToGroup"
      :disabled="isDisabled"
    >
      Done
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseAutocomplete from '@/components/form/BaseAutocomplete.vue';

import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'AddCampaignToGroupModal',
  components: {
    BaseAutocomplete,
  },
  props: {
    advertiserId: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      existingCampaignGroupName: '',
      campaignGroupName: '',
      campaignGroups: [],
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    modalRef() {
      return `addCampaignToGroupModal-${this.id}`;
    },
    isDisabled() {
      return !this.campaignGroupName || (this.campaignGroupName === this.existingCampaignGroupName);
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_EXISTING_CAMPAIGN,
      campaignTypes.PATCH_CAMPAIGN,
      campaignTypes.FETCH_CAMPAIGN_GROUPS,
    ]),
    showModal() {
      this.$refs[this.modalRef].show();
    },
    hideModal() {
      this.$refs[this.modalRef].hide();
    },
    addCampaignToGroup() {
      this.PATCH_CAMPAIGN({ group: this.campaignGroupName })
        .then(() => {
          this.hideModal();
          this.$emit('refreshTable');
        });
    },
    shownAddCampaignToGroupModal() {
      this.FETCH_CAMPAIGN_GROUPS({ advertiserId: this.advertiserId, customOnly: true })
        .then((response) => {
          this.campaignGroups = response;
        });

      this.FETCH_EXISTING_CAMPAIGN({ advertiserId: this.advertiserId, campaignId: this.id })
        .then((response) => {
          this.existingCampaignGroupName = response.group;
          this.campaignGroupName = response.group;
        });
    },
  },
};
</script>
